import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'color',
})
export class ColorPipe implements PipeTransform {
  transform(hex: string): string {
    if (!hex.includes('#')) {
      return hex;
    }

    let _hex = hex.replaceAll('#', '');

    while (_hex.length < 5) {
      _hex += _hex;
    }

    _hex = _hex.substring(0, 6);

    return `#${_hex}`;
  }
}
